// extracted by mini-css-extract-plugin
export default {"helpIcon":"Label_helpIcon__TbR7a","label":"Label_label__+XHYG","tooltip":"Label_tooltip__MIRdI","help":"Label_help__qd6BW"};